import GeneralInfoForm from './GeneralInfoForm';
import PreviewDropzone from './PreviewDropzone';
import React from 'react';
import RootChartRecap from './RootChartRecap';
import { styled } from '@mui/material';

const StyDetailsSectionContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
    marginTop: theme.spacing(5),
}));

const ChartTemplateDetailsStep = ({
    rootUrlActionsButtons = <></>,
}: {
    rootUrlActionsButtons?: React.ReactNode;
}): JSX.Element => {
    return (
        <StyDetailsSectionContainer>
            <GeneralInfoForm />
            <RootChartRecap rootUrlActionsButtons={rootUrlActionsButtons} />
            <PreviewDropzone />
        </StyDetailsSectionContainer>
    );
};

export default ChartTemplateDetailsStep;
